export default __webpack_public_path__ + "static/media/icn_arrow_down.f550b1e4.svg";